module.exports = __webpack_public_path__ + "static/explan.bc09f51b.png";